import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=f8403442"
import script from "./keyboard.vue?vue&type=script&lang=js"
export * from "./keyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports